/**
 * animVariables — module-level animation variable store.
 *
 * variableDefs  — list of variable definitions (name, type, defaultValue)
 * variableValues — current runtime values { name: value }
 *
 * variableDefs is synced from React state (BlueprintEditor).
 * variableValues is written by EventGraph / test UI, read by RuleEvaluator every frame.
 */

export const variableDefs = []
// [{ id: string, name: string, type: 'bool'|'float'|'int', defaultValue: any }]

export const variableValues = {}
// { [name]: currentValue }

export const constants = {}
// { [name]: value } — read-only values set by the system (e.g. session_id)

/**
 * Sync the full variable definition list from React state.
 * Always writes the current `value` field so the rule evaluator
 * sees up-to-date values immediately when the user edits them.
 */
export function syncVariables(defs) {
variableDefs.length = 0
  defs.forEach(d => variableDefs.push(d))

  // Remove orphaned runtime values
  for (const key of Object.keys(variableValues)) {
    if (!defs.find(d => d.name === key)) delete variableValues[key]
  }
  // Always sync current value — not just on first add
  for (const d of defs) {
    variableValues[d.name] = d.value
  }
}

export function setVariable(name, value) {
  // Auto-track the prior ConversationalState so typing-cancel / error chains
  // can restore it (via the RestorePreviousState blueprint node).
  if (name === 'ConversationalState') {
    const prior = variableValues[name]
    if (prior !== undefined && prior !== value) {
      variableValues.PreviousConversationalState = prior
    }
  }
  variableValues[name] = value
}

export function getVariable(name) {
  return variableValues[name] ?? constants[name] ?? null
}

export function setConstant(name, value) {
  constants[name] = value
}

export function getConstant(name) {
  return constants[name] ?? null
}
